var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-19.9%",
    y: "-15.4%",
    width: "139.9%",
    height: "130.9%",
    filterUnits: "objectBoundingBox",
    id: "cf99qeqpnb"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-22.3%",
    y: "-22.3%",
    width: "144.6%",
    height: "144.6%",
    filterUnits: "objectBoundingBox",
    id: "8l6h2iyvud"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "t7vm3jqjmc",
    cx: 5.935,
    cy: 10.507,
    r: 5.935
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0h12.287l-.085 7.829-2.49 2.82v5.51a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z",
    id: "5g5405jbsa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    transform: "rotate(-90 10.136 4.621)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#5g5405jbsa"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cf99qeqpnb)",
    xlinkHref: "#5g5405jbsa"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#5g5405jbsa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    d: "M22.596 9.614h-6.774"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    transform: "translate(1.173 1.47)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#t7vm3jqjmc"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#8l6h2iyvud)",
    xlinkHref: "#t7vm3jqjmc"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#t7vm3jqjmc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    strokeLinejoin: "round",
    d: "m4.402 11.977 2 1.826 3.631-3.413"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.60f7c531857dcadcd675cacb3134efe7.svg";
export { ForwardRef as ReactComponent };